import { render, staticRenderFns } from "./TopicSwiper.vue?vue&type=template&id=444a51dc&scoped=true"
import script from "./TopicSwiper.vue?vue&type=script&lang=js"
export * from "./TopicSwiper.vue?vue&type=script&lang=js"
import style0 from "./TopicSwiper.vue?vue&type=style&index=0&id=444a51dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a51dc",
  null
  
)

export default component.exports